import React from 'react';
import PropTypes from 'prop-types';

/**
 * MUI Components
 */
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

/**
 * Hooks
 */
import { useTranslation } from 'react-i18next';
import ListDocuments from './ListDocuments';

/**
 * View Work documents modal
 * @component
 * @param {boolean} open the open state
 * @param {function} handleClose the function to close the modal
 * @param {Object[]} documents the documents
 */
const ViewWorkDocumentsModal = ({ open, handleClose, documents }) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    overflowY: 'auto',
                    maxHeight: '100vh'
                }}
            >
                <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
                    {t('Work Documents')}
                </Typography>

                <ListDocuments items={documents} />

                <Button sx={{ marginTop: 4 }} onClick={handleClose} variant="contained" color="primary">
                    {t('Close')}
                </Button>
            </Box>
        </Modal >
    );
};

ViewWorkDocumentsModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    documents: PropTypes.array.isRequired,
};

export default ViewWorkDocumentsModal;

